const getFieldKey = (field: any) => field.id || field.name;

export default getFieldKey;
